import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { GlobalComponent } from "../../global-component";

const API_URL = GlobalComponent.API_URL;

@Injectable({ providedIn: 'root' })
export class TopBarService {

    user!: any;

    constructor(private http: HttpClient) { }

    getMenu(): Observable<any> {
        const cached = localStorage.getItem('menuData');
        if (cached) {
            return of(JSON.parse(cached));
        }

        const currentUser = localStorage.getItem('currentUser');
        if (currentUser) {
            this.user = JSON.parse(currentUser);
        }

        return this.http.get(`${API_URL}auth/menu?id=${this.user.userId}`).pipe(
            tap((data: any) => {
                if (data) localStorage.setItem('menuData', JSON.stringify(data));
            })
        );
    }
}

